import { Button, Divider, Drawer } from 'antd';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import TemplateItem from './TemplateItem';
import TemplateList from './TemplateList';

const StyledDivider = styled(Divider)`
  margin: 0px 0px;
`;

const StyledButton = styled(Button)`
  width: 100%;
`;

const StyledContainer = styled.div`
  margin-bottom: 32px;
`;

const TemplateDrawer = (props) => {
  const {
    onReset,
    collapsed,
    setCollapsed,
    idUsingTemplate,
    onCreate,
    onToggle,
    descriptionParams,
    composeDescription,
  } = props;

  const [description, setDescription] = useState('');
  useEffect(() => {
    composeDescription(setDescription);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [descriptionParams]);

  return (
    <Drawer
      title="Templates"
      placement="right"
      open={collapsed}
      onClose={() => setCollapsed(false)}
      width="25%"
      position="bottom"
      bodyStyle={{
        height: '80%',
        padding: '0px ',
      }}
    >
      <div>
        <StyledContainer>
          {idUsingTemplate ? undefined : (
            <>
              <TemplateItem
                onCreate={(name) => onCreate(name, description)}
                onToggle={(template) => onToggle(template)}
              />
              <StyledDivider />
            </>
          )}
          <TemplateList {...props} idUsingTemplate={idUsingTemplate} description={description} />
        </StyledContainer>
        <div className="button-add-template">
          <StyledButton
            onClick={() => {
              onReset();
            }}
            type="primary"
          >
            Add template
          </StyledButton>
        </div>
      </div>
    </Drawer>
  );
};

export default TemplateDrawer;
